import { auth } from '../firebaseConfig';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

export async function fixAdminAccess() {
  try {
    console.log('🔐 Fixing admin access...');
    
    const user = auth.currentUser;
    
    if (!user) {
      console.log('❌ No user logged in. Please log in first.');
      return { success: false, error: 'No user logged in' };
    }
    
    console.log(`👤 Current user: ${user.email} (${user.uid})`);
    
    // Get Firebase Functions
    
    // Call the setAdminClaims function
    const setAdminClaimsFunction = httpsCallable(functions, 'setAdminClaims');
    const result = await setAdminClaimsFunction({
      uid: user.uid,
      isAdmin: true,
      isLabeler: true
    });
    
    console.log('✅ Admin claims set successfully!');
    console.log('📋 Result:', result.data);
    
    // Force token refresh
    await user.getIdToken(true);
    console.log('🔄 Token refreshed. Please refresh your browser page.');
    
    return { success: true, result: result.data };
    
  } catch (error) {
    console.error('❌ Error setting admin claims:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
  }
}

// Auto-run when imported (for debugging)
if (typeof window !== 'undefined') {
  console.log('🔧 Admin access fixer loaded. Run fixAdminAccess() in console to fix your access.');
}
